import VDivider from "./main";

export default VDivider;
